<template>
  <Popover ref="pricePopover" :showHeader="true" headerTitle="Price Variation">
    <div class="p-2">
      <FormInputText
        type="number"
        ref="priceEntry"
        v-model="price"
        @enter="applyPriceVariation"
        :addonSlot="true">
        <template v-slot:addon>
                    
          <button data-toggle="dropdown" class="btn btn-white dropdown-toggle" type="button"></button>
          <ul class="dropdown-menu">
            <DropdownMenuItem 
              v-for="salesRate in pricingSalesRateList"
              :key="`rate-${salesRate.id}`"
              @click="price = calculateRatePrice(salesRate)"
              :icon="salesRateIcon(salesRate)"
              iconStyle="fas"
              :label="salesRate.name">
              <span class="mr-4">{{salesRate.name}}</span> <span class="font-weight-bold float-right">{{calculateRatePrice(salesRate) | formatCurrency}}</span>
            </DropdownMenuItem>
          </ul>
        </template> 
      </FormInputText>

      <div class="row mt-2">
        <div class="col-6 pr-1">
          <button class="btn btn-sm btn-default" :disabled="!isVariation" @click.prevent="removePriceVariation">
            <i class="far fa-trash-alt mr-2"></i>Remove Variation
          </button>
        </div>
        <div class="col-6 pl-1">
          <button class="btn btn-sm btn-default" @click.prevent="applyPriceVariation"><i class="far fa-check status-approved mr-2"></i> Apply Variation</button>
        </div>
      </div>
    </div>
  </Popover>
</template>


<script>
import { round } from 'mathjs'

import Popover from '@/components/popover'
import CustomerPriceListMixin from '@/modules/pricing/mixins/customerPriceListMixin.js'

export default {
  name: 'StockPriceListPricePopover',
  mixins: [CustomerPriceListMixin],
  components: {
    Popover
  },
  props: {
    pricingSalesRateList: Array,
  },
  data() {
    return {
      price: 0,
      stockSalesPrice: 0,
      isVariation: false,
      stockId: null,
      stockPriceGroupId: null,
      serviceRangeId: null
    }
  },
  methods: {
    displayPriceSelectionFromElement(el, stockId, stockPriceGroupId, serviceRangeId, price, stockSalesPrice, isVariation = false) {
      this.stockId = stockId
      this.stockPriceGroupId = stockPriceGroupId
      this.serviceRangeId = serviceRangeId
      this.price = price
      this.isVariation = isVariation
      this.stockSalesPrice = stockSalesPrice

      this.$refs.pricePopover.displayFromElement(el)
      this.$nextTick(() => {
        this.$refs.priceEntry.select()
      })
    },
    calculateRatePrice(salesRate) {
      return round(parseFloat(this.stockSalesPrice) + parseFloat(this.stockSalesPrice) * round(parseFloat(salesRate.percentAdjust) / 100.0, 2), 2)
    },
    applyPriceVariation() {
      var price = round(parseFloat(this.price), 2)
      if(isNaN(price))
        price = 0

      this.$emit('applyPriceVariation', {
        stockId: this.stockId,
        stockPriceGroupId: this.stockPriceGroupId,
        serviceRangeId: this.serviceRangeId,
        price: price
      })
      this.$refs.pricePopover.hidePopover()
    },
    removePriceVariation() {
      this.$emit('removePriceVariation', {
        stockId: this.stockId,
        stockPriceGroupId: this.stockPriceGroupId,
        serviceRangeId: this.serviceRangeId
      })
      this.$refs.pricePopover.hidePopover()
    },
    hidePopover() {
      this.$refs.pricePopover.hidePopover()
    }
  }
}
</script>